import { render } from "./EditMediaPress.vue?vue&type=template&id=6984b195&scoped=true"
import script from "./EditMediaPress.vue?vue&type=script&lang=js"
export * from "./EditMediaPress.vue?vue&type=script&lang=js"

import "./EditMediaPress.vue?vue&type=style&index=0&id=6984b195&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6984b195"]])

export default __exports__